module.exports = __webpack_public_path__ + "img/105.6.edaed9a8.png";